import React, {  PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import styles from './asset-item.styles';

class AssetItem extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
  };

  render() {
    const { children } = this.props;

    return (
      <View style={styles.root} testID="list-item">
        { children }
      </View>
    );
  }
}

export default AssetItem;
